import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const bookingEngineAtom = atom<{ isGoogleBE: boolean; bookingUrl: string }>({
    key: ATOM_KEY.BOOKING_ENGINE,
    default: {
        isGoogleBE: false,
        bookingUrl: "",
    },
});

export const useBookingRecoilState = () => useRecoilState(bookingEngineAtom);
export const useSetBookingRecoilState = () => useSetRecoilState(bookingEngineAtom);
export const useBookingRecoilValue = () => useRecoilValue(bookingEngineAtom);
